module.exports = "/_next/static/images/cb0e00f3f17c832d5c839296c4d1ade1-nobureaucracy@2x.png";